import { gql } from "apollo-boost"

export const UPDATE_INDICATORS = gql`
  mutation updateIndicators ($indicators: [CreateIndicatorInput!]!) {
    updateIndicators(indicators: $indicators) {
        id
    }
  }
`
